import { render, staticRenderFns } from "./FlexPanel.vue?vue&type=template&id=c13dcc4c&scoped=true"
import script from "./FlexPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlexPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FlexPanel.vue?vue&type=style&index=0&id=c13dcc4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13dcc4c",
  null
  
)

export default component.exports